import { render } from "./NosotrosPage.vue?vue&type=template&id=e885fefe"
import script from "./NosotrosPage.vue?vue&type=script&lang=js"
export * from "./NosotrosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__